import React, { useEffect, useRef, useState } from 'react'
import './CaseStudies.scss'
import CaseStudiesWidget from 'src/components/CaseStudiesWidget'


const CaseStudies = () => {
  const companyName = process.env.REACT_APP_COMPANY_NAME
  useEffect(() => {
    document.title = companyName + ' - Case Studies'

    let metaDescription = document.querySelector('meta[name="description"]')
    if (metaDescription) {
      metaDescription.setAttribute("content", `At ${companyName}, explore how we delivered exceptional solutions.`)
    }
  }, [])


  return (
    <>
      <div className="section-heading">
        <div className="container">
          <h1>Case Studies</h1>
          <div className="section-description">
            Explore how we delivered exceptional solutions.
          </div>
        </div>
      </div>

      <CaseStudiesWidget bckColorClass={'white-bck'} />


      <section className="section-quotes">
        <div className="container">
          <blockquote>
            “{companyName}’s goal is simple: to provide customers with specialist, cost-effective developers who can design and deliver exceptional web-based projects.”
            <br />
          </blockquote>
          <span>- Nikola Beljanski</span>&nbsp;&nbsp;<span>(Co-Founder)</span>
        </div>
      </section>
    </>
  )
}

export default CaseStudies